import { getApplicationSettings } from "owa-application-settings";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import { logGreyError } from "owa-analytics";
import { getPresenceCloudConfig } from "../config/cloudConfig";

export function getPresenceResource(): string {
    const mailboxInfo = getModuleContextMailboxInfo();
    if (isAccountFeatureEnabled("msplaces-presence-resource-appsetting", mailboxInfo)) {
        try {
            return getApplicationSettings("PresenceResource", mailboxInfo).authTargetResource;
        }
        catch {
            logGreyError("PresenceApplicationSettingError", mailboxInfo);
        }
    }
    return getPresenceCloudConfig().presenceResource;
}

export const PRESENCE_RETRY_COUNT = 1;
